import React, { Component } from 'react'
import PropTypes from "prop-types"
import { getExportListBoxes } from "../../../../services/api/apiNextBox"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { message } from 'antd'
import moment from 'moment'

class ExportListBoxes extends Component {
    state = {
        error: '',
        loading: false,
        exporting: false
    }

    _exportListBoxes = async () => {
        this.setState({
            exporting: true
        })

        const { closedAtGte, closedAtLt, FBABox, shippingCarrier, status, llcStatus, boxNumber, filter } = this.props
        const params = {
            ...filter
        }
        if (FBABox === "FBA") params.is_fba_box = true
        if (FBABox === "NOT_FBA") params.is_fba_box = false
        if (closedAtGte !== "") params.closed_at_gte = closedAtGte
        if (closedAtLt !== "") params.closed_at_lt = closedAtLt
        if (!!shippingCarrier && shippingCarrier.length > 0) params.shipping_carrier = [...shippingCarrier]
        if (llcStatus !== undefined) params.box_partner_status = llcStatus
        if (!!boxNumber && boxNumber.length > 0) params.search = boxNumber

        if (['opening', 'closed', 'shipped', 'ship_overdue'].includes(status)) {
            params.status = status
        }

        try {

            const { data } = await getExportListBoxes(params)
            const { message: mess } = data
            if (!!mess) {
                this.setState({
                    exporting: false
                })
                return message.error('Dữ liệu chưa được export!')
            }

            downloadFileFromData(data, { filename: `Boxes-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            this.setState({
                exporting: false
            })

        } catch (e) {
            this.setState({
                error: e.message,
                exporting: false
            })
        }
    }

    render() {
        const { exporting } = this.state

        return (
            <div className="ExportData ml-3">
                <button type="primary" className='btn btn-secondary' onClick={this._exportListBoxes}>
                    {exporting && <i className="fa fa-spinner fa-spin" />} {exporting ? 'Exporting' : 'Export boxes'}
                </button>
            </div>
        )
    }
}

ExportListBoxes.propTypes = {
    closedAtGte: PropTypes.string.isRequired,
    closedAtLt: PropTypes.string.isRequired,
    FBABox: PropTypes.string.isRequired
}

export default ExportListBoxes